/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { JumboStructsGCPServiceAccount } from './JumboStructsGCPServiceAccount';
import {
    JumboStructsGCPServiceAccountFromJSON,
    JumboStructsGCPServiceAccountFromJSONTyped,
    JumboStructsGCPServiceAccountToJSON,
} from './JumboStructsGCPServiceAccount';

/**
 * 
 * @export
 * @interface JumboGcpGCPBody
 */
export interface JumboGcpGCPBody {
    /**
     * 
     * @type {JumboStructsGCPServiceAccount}
     * @memberof JumboGcpGCPBody
     */
    keyValue?: JumboStructsGCPServiceAccount;
}

/**
 * Check if a given object implements the JumboGcpGCPBody interface.
 */
export function instanceOfJumboGcpGCPBody(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGcpGCPBodyFromJSON(json: any): JumboGcpGCPBody {
    return JumboGcpGCPBodyFromJSONTyped(json, false);
}

export function JumboGcpGCPBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGcpGCPBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'keyValue': !exists(json, 'keyValue') ? undefined : JumboStructsGCPServiceAccountFromJSON(json['keyValue']),
    };
}

export function JumboGcpGCPBodyToJSON(value?: JumboGcpGCPBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'keyValue': JumboStructsGCPServiceAccountToJSON(value.keyValue),
    };
}

